<template>
    <float-input
        type="date"
        @input="input"
        max="9999-12-31"
        :value="inputValue"
        v-bind="$attrs"
        v-on="xListeners(['input'])">
    </float-input>
</template>

<script>

import datetime_input from "@/components/inputs/mixins/datetime_input";
import xListeners from "@/mixins/xListeners";

export default {
    name: "FloatDate",
    mixins: [datetime_input, xListeners],
    props: {
        format: {
            default: 'dd-MM-yyyy'
        },
    },
    data() {
        return {
            inputFormat: 'yyyy-MM-dd',
        }
    }
}
</script>
